<template>
  <v-dialog v-model="show" max-width="700px" @keydown.esc="close()" @click:outside="$emit('close', false)">
    <v-card>
      <v-card-title>
        <span class="headline">Historial</span>
      </v-card-title>

      <v-card-text>
        <v-data-table v-if="check != null" :headers="headers" :items="check.history" item-key="id">
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.date }}</td>
              <td>
                <span :class="getClassState(props.item.state)">{{ props.item.state }}</span>
              </td>
              <td>
                <v-tooltip bottom v-if="props.item.state != ChequesState.STATE_EN_CARTERA && props.item.state != ChequesState.STATE_UTILIZADO && props.item.state == check.state"><!--Solo se puede revertir el estado actual -->
                  <template v-slot:activator="{ on }">
                    <v-icon :disabled="loading" v-on="on" small color="red" class="mr-2" @click="openRollback(props.item)"> delete </v-icon>
                  </template>
                  <span>Revertir</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="$emit('close')">Cerrar</v-btn>
      </v-card-actions>
    </v-card>

    <!-- Confirmacion del rollback con la fecha de impacto de la reversion -->
    <v-dialog v-model="dialog_rollback" max-width="400px" persistent>
      <v-card v-if="dialog_rollback">
        <v-card-title>
          <span class="headline">Revertir estado</span>
        </v-card-title>
        <v-card-text>
          <p>¿Desea revertir el estado <b>{{ check ? check.state : "" }}</b> del cheque?</p>
          <DatePickerEsp label="Fecha de reversión*" name="rollback_date" :date="rollback_date" :isRequired="true" @setDate="(date) => { rollback_date = date; }" />
          <!-- Cheque propio legacy sin chequera asociada: hay que elegir a que chequera vuelve -->
          <template v-if="requires_chequera">
            <p class="mt-3 orange--text">{{ requires_chequera_msg }}</p>
            <v-autocomplete v-model="chequera" :items="chequeras" item-text="name" item-value="id" label="Chequera*" return-object clearable />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text :disabled="loading" @click="dialog_rollback = false">Cancelar</v-btn>
          <v-btn color="success" text :loading="loading" :disabled="!rollback_date || (requires_chequera && !chequera)" @click="rollbackState(check)">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import ChequesState from "@/constants/chequesStates";
import { checkService } from "@/libs/ws/checkService";
import DatePickerEsp from "@/components/DatePickerEsp.vue";
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
export default {
  name: "HistoryModal",
  components: { DatePickerEsp },
  props: {
    show: Boolean,
    check: Object,
    refresh: Function,
    close: Function,
  },
  data() {
    return {
      headers: [
        {
          text: "Fecha",
          align: "left",
          sortable: true,
          value: "date",
        },
        { text: "Estado", value: "" },
        { text: "Accion", value: "action" },
      ],
      ChequesState: ChequesState,
      loading: false,
      dialog_rollback: false,
      rollback_date: null,
      requires_chequera: false,
      requires_chequera_msg: "",
      chequeras: [],
      chequera: null,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    getClassState(state) {
      return checkService.getClassState(state);
    },
    //Por defecto la reversion se fecha el dia del estado a revertir (el historial viene en dd/mm/aaaa)
    openRollback(historyItem) {
      const [day, month, year] = (historyItem.date || "").split("/");
      this.rollback_date = year ? `${year}-${month}-${day}` : null;
      this.requires_chequera = false;
      this.chequera = null;
      this.dialog_rollback = true;
    },
    loadChequeras(emitterId) {
      generalService.setSection(Constant.SECTION_MONEY_ACCOUNTS);
      generalService
        .filter({ account_type: "C", emitter_id: emitterId })
        .then((response) => {
          this.chequeras = response.result.filter((a) => a.parent_money_account != null);
        })
        .catch((e) => {
          console.log("chequeras.filter error");
          console.log(e);
        });
    },
    rollbackState(check) {
      if(this.loading) return;

      this.loading = true;
      checkService
        .rollbackState({
          id: check.id,
          state_to_rollback: check.state,
          date: this.rollback_date,
          money_account_associated_id: this.chequera ? this.chequera.id : null,
        })
        .then((res) => {
          if(res.status){
            this.dialog_rollback = false;
            this.$toast.success("El Cheque se modifico correctamente.", "OK");
            this.$emit("updateDialog", false);
            this.$emit("loadList");
            this.$emit("close");
          }else if(res.code == ChequesState.CODE_REQUIRES_CHEQUERA && check.emitter){
            this.requires_chequera = true;
            this.requires_chequera_msg = res.msg;
            this.loadChequeras(check.emitter.id);
          }else{
            this.$toast.error(res.msg, "Error");
          }
        })
        .catch((err) => {
          this.$toast.error(err.msg, "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
